import { BaseModal } from './baseModal'
import { createSelectors } from '../utils/selectorUtils';
import { createLogger } from '../utils/debugLogger';
import Awesomplete from 'awesomplete';
const l = createLogger('ModalDeparturePoint.js');

export class ModalDeparturePoint extends BaseModal {
    static Selectors = createSelectors({
        INPUT: {
            SELECTED: `data-ts-cb-departure-point`,
            ALL_DEPARTURE_POINTS: `data-ts-all-departure-points`,
            DEPARTURE_TYPEAHEAD: `data-ts-departure-typeahead`,
            DEPARTURE_CHECKBOX_BY_NAME: `data-ts-cb-departure-point-name`
        },
        BUTTONS: {
            SELECTED_DEPARTURE_POINT: `data-ts-departure-selected`
        }
    });

    static Config = {
        QUERY_STRING_KEY: 'filterdeparturepoints'
    }

    #awesomplete;

    constructor(modalName, queryStringManager = null) {
        super(modalName, queryStringManager);

        const parentLoadModalContent = this.loadModalContent.bind(this);

        this.loadModalContent = async (evt) => {
            await parentLoadModalContent(evt);

            if (!this.isLoaded) {
                l.log(`${this.modalName}: base not loaded`);
                return;
            }

            const typeaheadEle = document.querySelector(this.constructor.Selectors.INPUT.DEPARTURE_TYPEAHEAD);
            const allPoints = document.querySelector(this.constructor.Selectors.INPUT.ALL_DEPARTURE_POINTS).value;

            this.#awesomplete = new Awesomplete(typeaheadEle, {
                list: allPoints,
                minChars: 1
            });

            this.attachHandler(
                'typeaheadSelectedValue',
                (e) => {
                    const selectedDeparturePoint = e.text;
                    l.log("Selected Departure Point", selectedDeparturePoint);
                    const input = typeaheadEle;
                    input.value = '';
                    this.#awesomplete.close();

                    this.setSelectedDeparturePoint(selectedDeparturePoint);

                },
                `${this.constructor.Selectors.INPUT.DEPARTURE_TYPEAHEAD}`,
                ['awesomplete-selectcomplete']
            );

            this.attachHandler(
                'removeSelectedDeparturePoint',
                (e) => {
                    const val = e.target.closest('span').getAttribute('data-ts-departure-selected');
                    e.target.closest('span').style.display = 'none';
                    document.querySelector(`${this.constructor.Selectors.INPUT.SELECTED}[data-ts-cb-departure-point-name="${val}"]`).checked = false;
                },
                `${this.constructor.Selectors.BUTTONS.SELECTED_DEPARTURE_POINT}`,
                ['click']
            );

            this.attachHandler(
                'addSelectedDeparturePoint',
                (e) => {
                    const val = e.target.dataset.tsCbDeparturePointName;
                    const selector = `[${this.constructor.Selectors.raw.BUTTONS.SELECTED_DEPARTURE_POINT}='${val}']`;
                    const span = document.querySelector(selector);
                    if (span) {
                        span.style.display = e.target.checked ? '' : 'none';
                    }
                },
                `${this.constructor.Selectors.INPUT.SELECTED}`
            );


        }

        const parentclearSelected = this.clearSelected.bind(this);
        this.clearSelected = () => {
            parentclearSelected();
            l.log(`${this.modalName}: custom clear`);

            //Hide selected departure buttons
            document.querySelectorAll(this.constructor.Selectors.BUTTONS.SELECTED_DEPARTURE_POINT)
                .forEach(span => {       
                    span.style.display = 'none';
                });
        }

        const parentDispose = this.dispose.bind(this);
        this.dispose = async function () {
            await parentDispose();
            if (this.#awesomplete) {
                this.#awesomplete.destroy();
                this.#awesomplete = null;
            }
        }
    }

    //Check Departure Checkbox
    setSelectedDeparturePoint(departurePoint) {
        const cbSelector = `[${this.constructor.Selectors.raw.INPUT.DEPARTURE_CHECKBOX_BY_NAME}='${departurePoint}']`;
        const cb = document.querySelector(cbSelector);
        cb.checked = true;

        //Add Selected Button
        const buttonSelector = `[${this.constructor.Selectors.raw.BUTTONS.SELECTED_DEPARTURE_POINT}='${departurePoint}']`;
        const span = document.querySelector(buttonSelector);
        span.style.display = '';
    }

    static createModal(queryStringManager = null) {
        return BaseModal.create.call(this, 'ModalDeparturePoint', queryStringManager);
    }
}